const translations = {
  page_title: 'Dealers',
  add_new_account: 'Add new dealer',
  login_as: 'Login as user',
  unexpire_vehicle: 'Unexpire vehicle',
  import_stock_photos: 'Import stock photos',
  account: 'Account',
  vehicles: 'Vehicles',
  users: 'Users',
  total_accounts: 'Total accounts',
  unexpire: 'Unexpire',
  vin: 'VIN',
  vehicles_updated: 'Vehicles updated',
  disable_account: 'Disable account',
  disable_account_description:
    'You are about to disable this account and its users will not be able to access or perform any further actions. You can re-enable it at any time.',
  enable_account: 'Enable account',
  enable_account_description:
    'You are about to enable a previously disabled account. All users associated with this account will be accessible again.',
  account_disabled: 'Account disabled',
  account_enabled: 'Account enabled',
  vehicle_unexpired: 'Vehicle unexpired',
  images_imported: 'Images imported',
  import_photos_description:
    'Updated stock images will be imported for those vehicles that do not have user-uploaded images.',
  section_accounts_description:
    'These are the registered dealers with active accounts at INV360. From here you can edit it’s information or take control of the account using a dealer active user.',

  cancel_new_account: 'Discard new account',
  cancel_new_account_description: 'All data entered will be lost, this action cannot be undone.',
  discard_account: 'Discard account',

  enabled: 'Enabled',
  disabled: 'Disabled',
  status: 'Status',
  all: 'All',

  there_are_no_matches: 'There are no matches for your search',
  choose_ohter_search: 'Choose other search criteria and try again',

  add_country: 'Add country',
  search_country: 'Search country',
  country_added: 'The country was added successfully',
  country_removed: 'The country was removed',
  country_changed_successfully: 'Country updated successfully',
  select_countries: 'Select countries',

  actions: 'Actions',

  pages: 'Pages',
  wordpress: 'Wordpress',
  agent: 'Agent',
  dealer: 'Dealer',
};

export default translations;
